import { render, staticRenderFns } from "./ChannelFilterLoader.vue?vue&type=template&id=23cc8046&scoped=true"
import script from "./ChannelFilterLoader.vue?vue&type=script&lang=js"
export * from "./ChannelFilterLoader.vue?vue&type=script&lang=js"
import style0 from "./ChannelFilterLoader.vue?vue&type=style&index=0&id=23cc8046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cc8046",
  null
  
)

export default component.exports